import React from 'react';

const Names = ({name,setCurrentName, addFavourites })=>{
   const handleClick =()=>{
       setCurrentName(name)
       addFavourites(name.name)
   }
   
    return(
        <a onClick={handleClick}>
            <div>
               <li className={name.sex} >
                  <i style={{ paddingRight: "15px"}} className="far fa-smile"/>
                   {name.name}
                </li>
            </div>
        </a>
    )
}
export default Names;


// WEBPACK FOOTER //
// ./src/components/mainpage/Names.js